import { resolveShowBuy } from './resolveShowBuy';

export const needsToBuyAsSubscriber = ({
  isStoreExclusive,
  availableFor,
  isPlusUser,
  isIconicUser,
  isIconicProUser,
  isEnrolled,
  hasAccessToCourse,
  userSubscriptionType
}) => {
  const hasAvailableForList =
    Array.isArray(availableFor) && availableFor.length > 0;

  return !!(
    isStoreExclusive &&
    hasAvailableForList &&
    (isPlusUser || isIconicUser || isIconicProUser || isEnrolled) &&
    resolveShowBuy(hasAccessToCourse, availableFor, userSubscriptionType)
  );
};

export default needsToBuyAsSubscriber;
